import { Grid, Typography, Box } from "@mui/material";
import companyLogo from "../../../assets/images/nirantara_logo_new.svg";
import vajraPoweredByLogo from "../../../assets/images/vajra_powered_by_logo.svg";
import { getSubdomainLabel } from "../../../utils/consultantDomain";
import LoginSlider from "../../Login/LoginSlider";
import "../../SSO/sso.css";
import failure from "../../../assets/Login/failure.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const Success = () => {
  return (
    <div className="sso-page-container">
      {/* Left Section - Image (remains same) */}
      <Grid item className="sso-left-panel">
        <LoginSlider />
      </Grid>

      {/* Right Section - Toggle between Login and OTP */}
      <Grid item className="sso-right-panel">
        <Box className="sso-right-content">
          <div className="sso-container">
            <img src={failure} alt="Failure" className="sso-failure-image" />
            <p className="success-text">Authentication failed!</p>
            <p className="success-text-secondary">
              We were unable to authenticate your account. Not authorized to
              access this application.
            </p>
            <div
              className="back-to-login-button"
              onClick={() => (window.location.href = "/login")}
            >
              <ArrowBackIcon sx={{ fontSize: 20, color: "#6b6968" }} />
              Back to Login
            </div>
          </div>
          {/* Footer (remains same for both views) */}

          <Typography
            variant="body2"
            color="textSecondary"
            className="sso-footer"
          >
            Powered by
            <span className="sso-footer-logo-wrap">
              <img
                src={getSubdomainLabel() ? vajraPoweredByLogo : companyLogo}
                alt="Company Logo"
                className="sso-footer-logo"
              />
            </span>
          </Typography>
        </Box>
      </Grid>
    </div>
  );
};

export default Success;
